'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'radio-tuner';
var width = 512;
var height = 512;
var aliases = ["radio-alt"];
var unicode = 'f8d8';
var svgPathData = 'M485.7 55.3L509 49.6 497.6 3 474.3 8.7l-456 112L0 125.2 0 128l0 16 0 32L0 304l0 24L0 464l0 48 48 0 416 0 48 0 0-48 0-288 0-48-48 0-274.2 0 296-72.7zM48 272l416 0 0 192L48 464l0-136 0-24 0-32zM368 432a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM80 320l0 32 16 0 128 0 16 0 0-32-16 0L96 320l-16 0zm16 64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRadioTuner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;